const state = {
  plans: null
}

const getters = {
  plans: state => state.plans
}

const mutations = {
  SET_PLANS (state, plans) {
    const { list } = plans
    state.plans = list
  }
}

export default {
  state,
  getters,
  mutations
}
